import { memo, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { UserForm } from '../../../components/form/user-form/user-form';
import { validateUser } from '../../../models/validate-user';
import { useUser } from '../../../components/form/user-form/use-user';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IEditMemberModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  handleEditMember: (data: any) => void;
  selectMember: any;
  selectedMember: any;
  managedByList: any;
}

const EditMemberModal = ({
  open,
  handleClose,
  handleEditMember,
  selectMember,
  selectedMember,
  managedByList,
}: IEditMemberModalProps) => {
  const { updateUser, user } = useUser(selectedMember);
  const { fieldErrors, hasErrors } = validateUser(user, ['password']);

  useEffect(() => {
    handleClose();
  }, [selectMember.loading]);

  const intl = useIntl();

  const onClickActionButton = () => {
    if (!hasErrors) {
      const memberData = {
        id: user.id,
        name: user.profile.name,
        contactNumber: user.profile.contactNumber,
        email: user.email,
        parentId: user.parentId,
        status: user.status,
      };
      handleEditMember(memberData);
    }
  };

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'edit_member',
      })}
      id="edit-member-modal"
      open={open}
      isSingleButton
      handleClose={handleClose}
      actinButtonOnClick={onClickActionButton}
      actionButtonDisabled={hasErrors}
      actinButtonLabel={intl.formatMessage({
        id: 'continue',
      })}
    >
      <UserForm
        user={user}
        updateUser={updateUser}
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          contactNumber: {
            error: fieldErrors.contactNumber,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
          status: {
            error: fieldErrors.status,
            required: true,
          },
          parentId: {
            error: fieldErrors.parentId,
            required: true,
            managedByList: managedByList,
          },
        }}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(EditMemberModal));
